<template>
  <div class="color-main-pallete-content" id="identidade-visual-cores-paleta-principal" data-search-anchor>
    <div class="color-main-pallete-title-wrapper">
      <h1 class="color-main-pallete-title-span">{{ colorMainPalleteTitleSpan }}</h1>
      <h1 class="color-main-pallete-title">{{ colorMainPalleteTitle }}</h1>
    </div>
    <div class="description-color-main-pallete-title-icons-wrapper">
      <p class="color-main-pallete-description">{{ colorMainPalleteDescription1 }}</p>
      <p class="color-main-pallete-description">{{ colorMainPalleteDescription2 }}</p>
      <div class="color-main-pallete-icon-wrapper-first">
        <IconCheck />
        <p class="color-main-pallete-description-icon">{{ colorMainPalleteDescription3 }}</p>
      </div>
      <div class="color-main-pallete-fica-a-dica-wrapper">
        <p class="fica-a-dica">{{ colorMainPalleteDescription4 }}</p>
        <p class="color-main-pallete-description">{{ colorMainPalleteDescription5 }}</p>
      </div>      
    </div>
    <div
      class="color-main-pallete-card-item"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>     
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import ColorPageMixin from '@/mixins/color-page-mixin'
import { ColorPageStore } from '@/store/visual-identity-page/color-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import IconCheck from '@/assets/icons/IconCheck.vue'

@Component({
  components: {
    IconCheck    
  }
})
export default class ColorsMainPalleteSection extends Mixins(ColorPageMixin) {
  colorPageStore: PageStoreContract = getModule(ColorPageStore, this.$store)

  get colorMainPalleteTitleSpan(): string {
    return this.getElementTitle(3, 0)
  }

  get colorMainPalleteTitle(): string {
    return this.getElementText(3, 0)
  }

  get colorMainPalleteDescription1(): string {
    return this.getElementText(3, 1)
  }

  get colorMainPalleteDescription2(): string {
    return this.getElementText(3, 2)
  }

  get colorMainPalleteDescription3(): string {
    return this.getElementText(3, 3)
  }

  get colorMainPalleteDescription4(): string {
    return this.getElementText(3, 4)
  }

  get colorMainPalleteDescription5(): string {
    return this.getElementText(3, 5)
  }

  get ImageSrc(): string {
    return this.getElementMedia(3, 6)
  }

  async getColorPage(): Promise<void> {
    await this.colorPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.colorPageStore.isLoading) {
      await this.getColorPage()
    }
  }
}
</script>

<style lang="scss">
.color-main-pallete-content{
  display: grid;
  max-width: 1032px;
  width: 100%;
}

.color-main-pallete-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.color-main-pallete-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}

.color-main-pallete-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.description-color-main-pallete-title-icons-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 51.5% 48.5%;
  align-items: start;
}

.color-main-pallete-description {  
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  margin-top: 0;
  width: 430px;
}


.color-main-pallete-icon-wrapper-first {
  display: flex;
  align-items: center;
}

.color-main-pallete-description-icon {  
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  width: 378px;  
  padding-left: 7px;
}

.color-main-pallete-fica-a-dica-wrapper {
  margin-top: 1rem;
}

.color-main-pallete-card-item {
  position: relative;
  max-width: 1032px;
  width: 100%;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.button-main-pallete-wrapper {
  display: flex;
  align-items: center;
  padding-top: 2.5rem;
}
</style>
